<template>
  <div class="product-view" id="Leads">
    <div style="width: 100%;">
      <h3 class="headerTitle">
        Potenciales: Desde el {{ date.startDateInText }} Hasta el
        {{ date.endDateInText }}
      </h3>

      <!-- Modal -->
      <div v-if="isModalVisible" class="modal-overlay" @click="closeModal">
        <div class="modal" @click.stop>
          <h3 style="margin: 10px 0px;">ℹ️ Información del Lead</h3>
          <p style="margin: 10px 0px;" class="content">{{ leadInfo }}</p>
          <button @click="closeModal" style="margin: 10px 0px;">Cerrar</button>
        </div>
      </div>

      <!-- Contadores de Leads -->
      <div class="lead-stats">
        <div
          class="stat new"
          @click="getLeadsByFilterStatus('Nuevo')"
          :class="{ active: filteredStatus === 'Nuevo' }"
        >
          Nuevos <span>{{ summary.totalLeadsNew }}</span>
        </div>
        <div
          class="stat not-contacted"
          @click="getLeadsByFilterStatus('No Contactado')"
          :class="{ active: filteredStatus === 'No Contactado' }"
        >
          No Contactados <span>{{ summary.totalLeadsNotContacted }}</span>
        </div>
        <div
          class="stat in-followup"
          @click="getLeadsByFilterStatus('En Seguimiento')"
          :class="{ active: filteredStatus === 'En Seguimiento' }"
        >
          En Seguimiento <span>{{ summary.totalLeadsInFollowUp }}</span>
        </div>
        <div
          class="stat contacted"
          @click="getLeadsByFilterStatus('Contactado')"
          :class="{ active: filteredStatus === 'Contactado' }"
        >
          Contactados <span>{{ summary.totalLeadsContacted }}</span>
        </div>
        <div
          class="stat total"
          @click="getLeadsByFilterStatus('')"
          :class="{ active: filteredStatus === '' }"
        >
          Leads totales <span>{{ summary.totalLeads }}</span>
        </div>
      </div>

      <!-- Botones de Exportación -->
      <div class="export-buttons">
        <button
          class="export-button excel"
          :class="{ active: selectedFormat === 'excel' }"
          @click="exportToExcel"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/3/34/Microsoft_Office_Excel_%282019%E2%80%93present%29.svg"
            alt="Excel"
          />
          Excel
        </button>
        <button
          class="export-button pdf"
          :class="{ active: selectedFormat === 'pdf' }"
          @click="exportToPDF"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg"
            alt="PDF"
          />
          PDF
        </button>
        <button
          class="export-button csv"
          :class="{ active: selectedFormat === 'csv' }"
          @click="exportToCSV"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/8242/8242984.png"
            alt="CSV"
          />
          CSV
        </button>
      </div>

      <!-- Table ag-grid-vue-->
      <ag-grid-vue
        style="width: 100%; height: 500px;"
        class="ag-theme-alpine"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :defaultColDef="defaultColDef"
        rowSelection="single"
        :pagination="false"
        :paginationPageSize="pagination.limit"
        @gridReady="onGridReady"
        :context="{ componentParent: this }"
        :enableCellTextSelection="true"
      >
      </ag-grid-vue>

      <!-- Paginación -->
      <div style="width: 100%; background-color: white; padding: 10px 0px;">
        <el-pagination
          :currentPage="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.totalPagination"
          @current-change="changePage($event)"
          @prev-click="changePage($event)"
          @next-click="changePage($event)"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//services 🏗️
import { ServiceFactory } from "../services";

//packages 📦
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

//export packages 📦
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

function SaveButtonRenderer(params) {
  const button = document.createElement("button");
  button.innerHTML = "💾";
  button.style.border = "none";
  button.style.background = "transparent";
  button.style.cursor = "pointer";
  button.onclick = () => {
    if (params.context.componentParent.handleSave) {
      params.context.componentParent.handleSave(params.data);
    }
  };
  return button;
}

function InfoButtonRenderer(params) {
  const button = document.createElement("button");
  button.innerHTML = "ℹ️";
  button.style.border = "none";
  button.style.background = "transparent";
  button.style.cursor = "pointer";
  button.onclick = () => {
    if (params.context.componentParent.handleInfo) {
      params.context.componentParent.handleInfo(params.data);
    }
  };
  return button;
}

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      isModalVisible: false,
      leadInfo: "",
      gridApi: null,
      summary: {
        page: 0,
        limit: 0,
        offset: 0,
        totalLeads: 0,
        totalLeadsNew: 0,
        totalLeadsContacted: 0,
        totalLeadsNotContacted: 0,
        totalLeadsInFollowUp: 0
      },
      selectedFormat: "",

      exportedFileName: "",

      date: {
        startDateInText: "",
        endDateInText: "",
        startDate: "",
        endDate: ""
      },
      filteredStatus: "",
      queryParams: {
        businessUnitId: "",
        subscriberId: ""
      },
      rowData: [],
      columnDefs: [
        // { headerName: "No", field: "no", sortable: true, width: 60 },
        { headerName: "Id", field: "id", width: 80, hide: true },
        { headerName: "Nombre", field: "nombre", width: 200, resizable: true },
        {
          headerName: "Teléfono",
          field: "telefono",
          width: 175,
          resizable: true
        },
        { headerName: "Email", field: "email", width: 260, resizable: true },
        { headerName: "Fuente", field: "fuente", width: 125 },
        {
          headerName: "Info",
          field: "info",
          cellRenderer: InfoButtonRenderer,
          width: "70px",
          cellStyle: { textAlign: "center" }
        },
        { headerName: "Registro", field: "registro", width: 250 },
        {
          headerName: "Estado",
          field: "estado",
          editable: true,
          width: "160px",
          cellEditor: "agSelectCellEditor",
          singleClickEdit: true,
          cellEditorParams: {
            values: ["Nuevo", "Contactado", "No Contactado", "En Seguimiento"]
          },
          cellStyle: params => ({
            backgroundColor: this.getEstadoColor(params.value),
            color: "#000",
            textAlign: "center",
            borderRadius: "20px",
            display: "inline-block",
            marginTop: "5px",
            height: "30px",
            lineHeight: "30px",
            cursor: "pointer"
          }),
          cellRenderer: params => {
            return `<span>${params.value} <span style="color: #555; font-size: 12px; margin-left:10px">▼</span></span>`;
          }
        },
        {
          headerName: "Acciones",
          cellRenderer: SaveButtonRenderer,
          width: 100,
          cellRendererParams: {},
          cellStyle: { textAlign: "center" }
        }
      ],
      pagination: {
        totalPagination: 0,
        currentPage: 1,
        limit: 10,
        offset: 0
      },
      defaultColDef: {
        suppressMovable: true,
        resizable: false,
        sortable: false,
        filter: false
      },
      LeadsService: () => {}
    };
  },
  mounted: async function() {
    const { subscriberId, businessUnitId } = this.$route.params;
    this.date.startDate = this.$store.state.subscriber.date2;
    this.date.endDate = this.$store.state.subscriber.date1;
    this.queryParams.businessUnitId = businessUnitId;
    this.queryParams.subscriberId = subscriberId;
  },
  watch: {
    date1: async function() {
      this.date.startDate = this.$store.state.subscriber.date2;
      this.date.endDate = this.$store.state.subscriber.date1;
      this.reset();
      this.getLeads();
    },
    date2: async function() {
      this.date.startDate = this.$store.state.subscriber.date2;
      this.date.endDate = this.$store.state.subscriber.date1;
      this.reset();
      this.getLeads();
    }
  },
  async created() {
    const { Name } = this.$store.state.subscriber.client;
    this.exportedFileName = `${Name} - Leads`;

    this.LeadsService = await ServiceFactory.createInstance({
      type: "LeadsService",
      data: this
    });

    this.getLeads();
  },
  methods: {
    reset() {
      this.pagination.currentPage = 1;
      this.filteredStatus = "";
    },
    async changePage(page) {
      this.pagination.currentPage = page;
      this.getLeads();
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("es-ES", options);
    },
    async getLeads() {
      const subscriberId = this.queryParams.subscriberId;
      const businessUnitId = this.queryParams.businessUnitId;
      const startDate = this.date.startDate;
      const endDate = this.date.endDate;
      const status = this.filteredStatus;
      const page = this.pagination.currentPage;
      const offset = this.pagination.offset;
      const limit = this.pagination.limit;

      const LEADS = await this.LeadsService.GetLeads({
        businessUnitId,
        subscriberId,
        startDate,
        endDate,
        status,
        offset,
        limit,
        page
      });

      this.rowData = LEADS.data.map((l, i) => ({
        // no: (this.pagination.currentPage - 1) * limit + i + 1,
        id: l.leadid,
        nombre: l.leadname,
        telefono: this.formatPhone(l.leadphone),
        email: l.leademail,
        info: l.leadinformation,
        fuente: l.platformsource,
        registro: this.formatCellDate(l.leaddate),
        estado: l.status
      }));

      switch (status) {
        case "Nuevo":
          this.pagination.totalPagination = LEADS.summary.totalLeadsNew;
          break;
        case "Contactado":
          this.pagination.totalPagination = LEADS.summary.totalLeadsContacted;
          break;
        case "No Contactado":
          this.pagination.totalPagination =
            LEADS.summary.totalLeadsNotContacted;
          break;
        case "En Seguimiento":
          this.pagination.totalPagination = LEADS.summary.totalLeadsInFollowUp;
          break;
        default:
          this.pagination.totalPagination = LEADS.summary.totalLeads;
          break;
      }

      this.date.startDateInText = this.formatDate(this.date.startDate);
      this.date.endDateInText = this.formatDate(this.date.endDate);
      this.summary = LEADS.summary;
    },
    formatCellDate(dateString) {
      const date = new Date(dateString);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "pm" : "am";

      hours = hours % 12 || 12;

      return `${year} / ${month} / ${day} . ${hours}:${minutes} ${ampm}`;
    },
    formatPhone(data) {
      let digits = data.replace(/\D/g, "");
      let phone = "";

      if (digits.startsWith("1") && digits.length > 10) {
        digits = digits.slice(0, 11);
        phone = `+1 (${digits.slice(1, 4)}) ${digits.slice(
          4,
          7
        )}-${digits.slice(7)}`;
      } else {
        digits = digits.slice(0, 10);
        if (digits.length <= 3) {
          phone = digits;
        } else if (digits.length <= 6) {
          phone = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        } else {
          phone = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(
            6
          )}`;
        }
      }
      return phone;
    },
    handleInfo(data) {
      const { info } = data;
      this.leadInfo = info;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    async handleSave(data) {
      let status = await this.LeadsService.UpdateLeadsStatus({
        leadId: data.id,
        status: data.estado
      });

      if (status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Estado actualizado: ${data.estado} para el registro: ${data.nombre}`,
          showConfirmButton: false,
          timer: 2000
        });
        this.getLeads();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: `Error al actualizar el estado del registro: ${data.nombre}`
        });
      }
    },
    async getLeadsByFilterStatus(status) {
      this.reset();
      this.filteredStatus = status;
      this.getLeads();
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    getEstadoColor(estado) {
      switch (estado) {
        case "Nuevo":
          return "#d1e3ff";
        case "Contactado":
          return "#d4f8d4";
        case "No Contactado":
          return "#f8d4d4";
        case "En Seguimiento":
          return "#f8e7b4";
        default:
          return "#fff";
      }
    },
    async getLeadsToExport() {
      const subscriberId = this.queryParams.subscriberId;
      const businessUnitId = this.queryParams.businessUnitId;
      const startDate = this.date.startDate;
      const endDate = this.date.endDate;
      const status = this.filteredStatus;

      const data = await this.LeadsService.GetLeadsToExport({
        businessUnitId,
        subscriberId,
        startDate,
        endDate,
        status
      });

      const dataToExport = data.map(l => ({
        Nombre: l.leadname || "***",
        Telefono: this.formatPhone(l.leadphone) || "***",
        Email: l.leademail || "***",
        Info: l.leadinformation || "***",
        Fuente: l.platformsource || "***",
        Registro: this.formatCellDate(l.leaddate) || "***",
        Estado: l.status || "***"
      }));

      return dataToExport;
    },
    // 📄 Exportar a CSV
    async exportToCSV() {
      this.selectedFormat = "csv";
      const data = await this.getLeadsToExport();

      if (data.length === 0) {
        console.warn("No hay datos para exportar.");
        Swal.fire({
          position: "center",
          icon: "error",
          title: `Oops... No hay datos para exportar.`,
        });
        return;
      }

      // Encabezados del CSV
      const headers = Object.keys(data[0]).join(",");

      // Función para manejar valores con comas o saltos de línea
      const escapeValue = value => {
        if (typeof value === "string") {
          return `"${value.replace(/"/g, '""').replace(/\n/g, " ")}"`; // Escapa comillas dobles y saltos de línea
        }
        return `"${value}"`;
      };

      // Formatear filas del CSV correctamente
      const rows = data
        .map(row =>
          Object.values(row)
            .map(escapeValue)
            .join(",")
        )
        .join("\n");

      // Crear el contenido del CSV
      const csvContent = `${headers}\n${rows}`;

      // Crear y descargar el archivo CSV
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `${this.exportedFileName}.csv`);
    },

    // 📊 Exportar a Excel
    async exportToExcel() {
      this.selectedFormat = "excel";
      const data = await this.getLeadsToExport();

      if (data.length === 0) {
        console.warn("No hay datos para exportar.");
        Swal.fire({
          position: "center",
          icon: "error",
          title: `Oops... No hay datos para exportar.`,
        });
        return;
      }

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Leads");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      saveAs(blob, `${this.exportedFileName}.xlsx`);
    },
    // 📜 Exportar a PDF
    async exportToPDF() {
      this.selectedFormat = "pdf";

      const doc = new jsPDF({
        orientation: "landscape", // Mejor para tablas anchas
        unit: "mm",
        format: "a4"
      });

      doc.setFontSize(14);
      doc.text( `${this.exportedFileName} Potenciales: Desde el ${this.date.startDateInText} Hasta el ${this.date.endDateInText}`, 14, 10);

      const data = await this.getLeadsToExport();

      if (data.length === 0) {
        console.warn("No hay datos para exportar.");
        Swal.fire({
          position: "center",
          icon: "error",
          title: `Oops... No hay datos para exportar.`,
        });
        return;
      }

      const headers = Object.keys(data[0]).map(h => ({ title: h, dataKey: h }));
      const rows = data.map(row => {
        return Object.fromEntries(
          Object.entries(row).map(([key, value]) => [key, value || ""])
        ); // Evita valores undefined
      });

      doc.autoTable({
        head: [headers.map(h => h.title)], // Encabezados
        body: rows.map(row => headers.map(h => row[h.dataKey])),
        startY: 20,
        theme: "striped", // Estilizado
        styles: {
          fontSize: 8,
          cellPadding: 2,
          overflow: "linebreak" // Evita cortar texto
        },
        columnStyles: {
          0: { cellWidth: 35 }, // Ajusta ancho de columnas
          1: { cellWidth: 35 },
          2: { cellWidth: 45 },
          3: { cellWidth: 60 },
          4: { cellWidth: 30 },
          5: { cellWidth: 35 },
          6: { cellWidth: 30 }
        }
      });

      doc.save(`${this.exportedFileName}.pdf`);
    }
  },
  computed: {
    ...mapGetters(["date1", "date2", "client"])
  }
};
</script>

<style lang="scss">
@import "./../assets/scss/components/lead.scss";
</style>
